import script from "./DetailTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailTitle.vue?vue&type=script&setup=true&lang=ts"

import "./DetailTitle.vue?vue&type=style&index=0&id=5928467c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5928467c"]])

export default __exports__